import { PaymentSource } from '.'

export interface WindowExports {
  name: 'smart-fields'
  fundingSource: PaymentSource
  isValid: () => boolean
}
